import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { isAdvertorial } from '../advertorial/advertorial';
import { figureOutPriorityTag } from '../../../utils/ad_util';

function showLive(live) {
  if (live) {
    return (
      <li className="eyebrow__item eyebrow__item--live">
        <span className="eyebrow__live">Live</span>
      </li>
    );
  }

  return null;
}

function renderTag(tags) {
  const eyeBrowText = figureOutPriorityTag(tags);
  const { slug } = eyeBrowText;
  let { name } = eyeBrowText;

  if (!slug || !name) {
    return null;
  }

  // console.log('render tag: name, slug', name, slug);

  name = name
    .replace(/\*/g, '')
    .replace(/_/g, ' ')
    .replace(/\s?advertorial/g, '');

  let to = `/section/${slug}`;

  if (to === '/section/most-creative-people') {
    to = '/most-creative-people';
  }

  if (name === 'LOreal') {
    name = "L'Oreal";
  }

  return (
    <li className="eyebrow__item">
      {isAdvertorial(tags) ? name : <Link to={to}>{name}</Link>}
    </li>
  );
}

function shouldShowTime(post) {
  const showTime = get(post, 'showTime');
  if (!showTime) return null;
  return <li className="eyebrow__item">{get(post, 'timePublished')} </li>;
}

export default function Eyebrow(props) {
  if (!props) {
    return null;
  }

  const { metadata, post, tags, modifier, live, insert } = props;

  if (!isEmpty(metadata)) {
    const cardTags = metadata.tags || [];
    let category = get(metadata, 'categories[0].name');

    // Handles coDesign posts category, if there's a tag that matches older legacy categories, use that instead
    if (category === 'Co.Design' && get(metadata, 'categories[1].name')) {
      category = get(metadata, 'categories[1].name');
    }

    let eyebrow = category || null;

    if (!eyebrow && metadata.dateFormatted && metadata.timePublished) {
      eyebrow = `${metadata.dateFormatted} | ${metadata.timePublished}`;
    }

    if (isAdvertorial(cardTags)) {
      // console.log('advertorial metadata eyeybrow, tags', metadata, tags);
      // console.log('1️⃣card tags', cardTags);
      let name;
      cardTags.forEach(entry => {
        if (entry.name.indexOf('*') !== -1) {
          // console.log('good entry', entry);
          name = entry.slug;
        }
      });

      // console.log('2️⃣name', name);
      const nameEdit = name.replace(/_/g, ' ');
      // console.log('3️⃣nameEdit', nameEdit);
      const nameFinal = nameEdit.replace(/advertorial/g, '');
      // console.log('4️⃣nameFinal', nameFinal)
      eyebrow = `Presented By ${nameFinal}`;
    }

    if (get(metadata, 'isSponsoredTile')) {
      // console.log('sponsored tile eyeybrow, tags', metadata, tags);
      eyebrow = '';
    }

    // When it's a News story, it has category Uncategorized
    // we don't want to show that to the user, use date instead
    if (eyebrow === 'Uncategorized') {
      eyebrow = metadata.timePublished;
    }

    if (metadata.customEyebrowText) {
      if (metadata.fullyReplaceEyebrow) {
        eyebrow = metadata.customEyebrowText;
      } else {
        eyebrow = isAdvertorial(cardTags)
          ? `Sponsored: ${metadata.customEyebrowText}`
          : metadata.customEyebrowText;
      }
    }

    return (
      eyebrow && (
        <span className={`eyebrow eyebrow--${modifier}`}>{eyebrow}</span>
      )
    );
  }

  if (!isEmpty(post)) {
    // console.log('post is alive', post);
    return (
      <ul className={insert ? 'eyebrow article__preview__eyebrow' : 'eyebrow'}>
        {showLive(live)}
        <li
          className={
            insert
              ? 'eyebrow__item article__preview__eyebrow__item'
              : 'eyebrow__item'
          }
        >
          <time dateTime={get(post, 'structuredData.published')}>
            {get(post, 'dateFormatted')}
          </time>
        </li>
        {shouldShowTime(post)}
        {renderTag(tags)}
      </ul>
    );
  }

  return null;
}

Eyebrow.defaultProps = {
  post: {},
  metadata: {},
  modifier: '',
  live: false,
  insert: false
};

Eyebrow.propTypes = {
  post: PropTypes.shape({}),
  // eslint-disable-next-line react/require-default-props
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  metadata: PropTypes.shape({}),
  modifier: PropTypes.string,
  live: PropTypes.bool,
  insert: PropTypes.bool
};
